export default __webpack_public_path__ + "static/kiro-0fe994b5a9fe3054b0ef00e8623f5e00.jpg";